import React from 'react'

import clsx from 'clsx'

import { useEventContext } from 'context/EventContext'

import classes from './ContentfulHyperlink.module.scss'

const ContentfulHyperlink = ({ children, ...rest }) => {
  const eventContext = useEventContext()

  return (
    <a
      className={clsx('ContentfulHyperlink', 'Contentful-link', 'evnt', classes.root)}
      {...rest}
      {...eventContext.addEvent({
        name: 'engagement_facet_click',
        engagementComponent: 'resources_article',
        engagementDestination: 'go-to_other-page',
        engagementDetails: 'text-link',
      })}
    >
      {children}
    </a>
  )
}

export default ContentfulHyperlink
